// utils/auth.js
export const checkTokenExpiry = (token) => {
  if (!token) return false;

  const [, payload] = token.split(".");
  const decodedPayload = JSON.parse(atob(payload));

  // Check if token has expired
  const currentTime = Math.floor(Date.now() / 1000);
  return currentTime >= decodedPayload.exp;
};
